import Helper from '@ember/component/helper';
import moment from 'moment-timezone';

export function formatDate([value, format = 'mm/dd/yyyy']) {
  return value.tz(moment.tz.guess()).format(format);
}

export default Helper.helper(formatDate);
